export const moduleName = 'notifications'
